import { gql } from "@apollo/client";

export const GET_VEHICLE_FEATURES = gql`
  query vehicleFeatures {
    vehicleFeatures
  }
`;
